import React from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Rulee from './components/rulee/Rulee';
import Login from './components/Login';
import ChildManagement from './components/child-management/ChildManagement';
import AdminPanel from './components/admin-panel/AdminPanel';
import LandingPage from './components/landing/LandingPage';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { t } from './utils/translations';

const getUiLanguage = () => localStorage.getItem('userLanguage') || 'en';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/" element={<PublicRoute><LandingPage /></PublicRoute>} />
              <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
              {/* <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} /> */}
              {/* Chat disabled for parents for now */}
              <Route path="/rulee" element={<ProtectedRoute><NoParentRoute><Rulee /></NoParentRoute></ProtectedRoute>} />
              <Route path="/parent" element={<ProtectedRoute><NoAdminRoute><ChildManagement /></NoAdminRoute></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute><AdminRoute><AdminPanel /></AdminRoute></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="loading">{t('loading', getUiLanguage())}</div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { isAuthenticated, loading, isParent, isAdmin } = useAuth();

  if (loading) {
    return <div className="loading">{t('loading', getUiLanguage())}</div>;
  }

  if (isAuthenticated) {
    // Redirect admins to admin panel, parents to parent management, children to rulee
    if (isAdmin) {
      return <Navigate to="/admin" replace />;
    }
    return <Navigate to={isParent ? "/parent" : "/rulee"} replace />;
  }

  return children;
}

function AdminRoute({ children }) {
  const { isAdmin, loading } = useAuth();

  if (loading) {
    return <div className="loading">{t('loading', getUiLanguage())}</div>;
  }

  if (!isAdmin) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function NoParentRoute({ children }) {
  const { isParent, loading } = useAuth();

  if (loading) {
    return <div className="loading">{t('loading', getUiLanguage())}</div>;
  }

  // Redirect parents away from rulee
  if (isParent) {
    return <Navigate to="/parent" replace />;
  }

  return children;
}

function NoAdminRoute({ children }) {
  const { isAdmin, loading } = useAuth();

  if (loading) {
    return <div className="loading">{t('loading', getUiLanguage())}</div>;
  }

  // Redirect admins away from parent panel
  if (isAdmin) {
    return <Navigate to="/admin" replace />;
  }

  return children;
}

export default App;
